import { render, staticRenderFns } from "./CustomerTreatmentItem.vue?vue&type=template&id=f4a96f10"
import script from "./CustomerTreatmentItem.vue?vue&type=script&lang=js"
export * from "./CustomerTreatmentItem.vue?vue&type=script&lang=js"
import style0 from "./CustomerTreatmentItem.vue?vue&type=style&index=0&id=f4a96f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports